import Image from "next/image";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import TextSubHeader from "@/components/typography/TextSubHeader";

export default function SwiperSlideImage({
  children,
  image,
}: React.PropsWithChildren<{
  children: React.ReactNode;
  image: string | StaticImport;
}>) {
  return (
    <div className="relative overflow-hidden rounded-lg">
      <Image
        src={image}
        alt={""}
        className="h-[450px] w-full object-cover lg:h-[500px]"
      />
      <TextSubHeader className="absolute inset-x-0 top-0 h-[40%] bg-gradient-to-b from-black/90 to-transparent pl-5 pr-12 pt-10 text-white lg:pl-7 lg:pr-10">
        {children}
      </TextSubHeader>
    </div>
  );
}
